import {Component, inject}               from '@angular/core';
import {FormsModule}                     from '@angular/forms';
import {MindConfIntf, MindRecordLogIntf} from '@djsharkk/logr-types'
import {takeUntil}                       from 'rxjs';
import {AuthUnlockService}               from '../../../../../../../logr-auth/utils/auth-unlock.service';
import {MenuCrudPanelContentBase}        from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}       from '../menu-crud-panel-top.component';
import {MenuCrudPanelMindService}        from './menu-crud-panel-mind.service';

@Component({
			   selector   : 'app-menu-crud-panel-mind',
			   imports    : [
				   FormsModule,
				   MenuCrudPanelTopComponent
			   ],
			   templateUrl: './menu-crud-panel-mind-top.component.html',
			   styleUrl   : './menu-crud-panel-mind-top.component.css'
		   })
export class MenuCrudPanelMindTopComponent extends MenuCrudPanelContentBase<MindRecordLogIntf, MindConfIntf> {
	svcAuthUnlock = inject(AuthUnlockService)
	svcMind = inject(MenuCrudPanelMindService)


	constructor() {
		super('mind', true);

		this.svcDataFactory.svcDataMind.mindConf
			.pipe(takeUntil(this.destroy$))
			.subscribe(confs => {
				this.recordRowsConf = confs;
				this.recordConfBtns = confs.map((c, i) => {
					return {
						uuid  : c.id as string,
						icon  : i.toString().padStart(2, `0`),
						text  : c.mind.split('_'),
						func  : () => this.svcMind.toggleItemInSelected(c.mind),
						active: () => this.svcMind.itemInSelected(c.mind)
					}
				}).sort((a, b) => b.icon.localeCompare(a.icon))


			})
	}


}
